module.exports = __webpack_public_path__ + "static/img/腾势Z9GT.177e968f.png";